import * as yup from 'yup';

export const paymentControllerSchema = yup
  .object()
  .shape({
    statusColumnId: yup.string().required('Payment Status Column is required'),
    statusColumnLabel: yup
      .string()
      .required('Payment Status Label is required'),
    isPaymentReminderEnabled: yup.boolean().default(false),
    remindAfter: yup.number().when('remindAfterEnabled', {
      is: true,
      then: (schema) => schema.required('Number of days is required.'),
      otherwise: (schema) => schema.optional(),
    }),
  })
  .required();
